<template>
  <div class="extra-style-page">
    <img src="../../../assets/images/extra-style/header.jpg">
    <!-- <img class="ranking" src="../../../assets/images/extra-style/ranking.png"> -->
    <div class="container">
      <div class="content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PagesWrapper',
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.extra-style-page {
  position: relative;
  width: 100%;
  font-size: 0;
  img {
    width: 100%;
  }
  .ranking {
    position: absolute;
    top: 50px;
    right: 0;
    width: 80px;
  }
  .container {
    padding-bottom: 20px;
    background: url('../../../assets/images/extra-style/bg.jpg') no-repeat;
    background-size: 100% 100%;
    .content {
      position: relative;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      width: 100%;
      min-height: 100px;
      padding-bottom: 10px;
      border-radius: 0.26667rem;
      background: #fff;
      .add-btn {
        z-index: 3;
        position: fixed;
        bottom: 10px;
        right: 10px;
        width: 50px;
      }
    }
    .return-btn {
      padding-top: 10px;
      text-align: center;
      img {
        width: 120px;
      }
    }
  }
}
</style>
